import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { DataTable } from '@uhg-abyss/web/ui/DataTable';
import { useDataTable } from '@uhg-abyss/web/hooks/useDataTable';
import { Layout } from '@uhg-abyss/web/ui/Layout';
import { Text } from '@uhg-abyss/web/ui/Text';
import { RequiredIcon } from './RequiredIcon';
import { CellKey } from './CellKey';
import { CellValue } from './CellValue';

export const ParameterTable = ({ parameters, title, setValue }) => {
  const handleChange = (value, row) => {
    const model = `${row.in}.${row.key}`;
    setValue(model, value);
  };

  const tableData = React.useMemo(() => {
    return (parameters || []).map((row, index) => {
      return {
        ...row,
        uniqueId: `${row?.in || 'param'}_${row?.key || 'key'}_${index}`,
      };
    });
  }, [parameters]);

  const columns = React.useMemo(() => {
    const colArray = [
      {
        header: 'Key',
        accessorKey: 'key',
        cell: (props) => {
          return <CellKey {...props} value={props.getValue()} />;
        },
      },
      {
        header: 'Value',
        accessorKey: 'value',
        cell: (props) => {
          return (
            <CellValue
              {...props}
              value={props.getValue()}
              onChange={handleChange}
            />
          );
        },
      },
      {
        header: 'Type',
        accessorKey: 'type',
        cell: (info) => {
          return info.getValue();
        },
      },
      {
        header: 'Description',
        accessorKey: 'description',
        cell: (info) => {
          return info.getValue();
        },
      },
    ];

    return colArray;
  }, []);

  const dataTableProps = useDataTable({
    initialData: tableData,
    initialColumns: columns,
    showPagination: false,
    disableResizing: true,
    rowIdKey: 'uniqueId',
  });

  useEffect(() => {
    dataTableProps.setData(tableData);
  }, [tableData]);

  return (
    <React.Fragment>
      <Layout.Group alignItems="top" space={4}>
        <RequiredIcon />
        <Text style={{ fontSize: '14px' }}>Required</Text>
      </Layout.Group>
      <DataTable
        title={title}
        css={{
          '.abyss-table-cell': {
            fontSize: '13px',
            b: {
              fontWeight: 400,
            },
          },
          '.abyss-table-header-data': {
            fontSize: '13px',
          },
          '.abyss-data-table-cell': {
            fontSize: '13px',
          },
          '.abyss-data-table-header-heading': {
            fontSize: '20px',
          },
          '.abyss-data-table-header-data': {
            fontSize: '14px',
            color: '#212223',
            fontWeight: 700,
          },
        }}
        tableState={dataTableProps}
      >
        <DataTable.Table />
      </DataTable>
    </React.Fragment>
  );
};

ParameterTable.propTypes = {
  title: PropTypes.string.isRequired,
  parameters: PropTypes.arrayOf(
    PropTypes.shape({
      key: PropTypes.string,
      description: PropTypes.string,
      value: PropTypes.string,
      required: PropTypes.bool,
      type: PropTypes.string,
    })
  ).isRequired,
  setValue: PropTypes.func.isRequired,
};
